/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';

/**
 * 
 * @export
 * @interface MacelloUpdateDTO
 */
export interface MacelloUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    idNazione: string;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MacelloUpdateDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MacelloUpdateDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof MacelloUpdateDTO
     */
    banca?: BancaDTO;
}

/**
 * Check if a given object implements the MacelloUpdateDTO interface.
 */
export function instanceOfMacelloUpdateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idNazione" in value;

    return isInstance;
}

export function MacelloUpdateDTOFromJSON(json: any): MacelloUpdateDTO {
    return MacelloUpdateDTOFromJSONTyped(json, false);
}

export function MacelloUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MacelloUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
    };
}

export function MacelloUpdateDTOToJSON(value?: MacelloUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
    };
}

